<template>
  <div
    v-if="layout === 'LIST'"
    class="comp-container comp-container__product-item comp-container__product-item--list"
    :class="{ 'is-sold-out': product.soldOut }"
    :data-id="product.id"
  >
    <div
      class="image POS-r MR-m BDRS-m BGC-light"
      v-if="product.image"
    >
      <div
        class="POS-a TRBL-0 BDRS-m BGR-n BGP-c-c BGZ-c"
        v-lazy:background-image="product.image"></div>
    </div>
    <div class="meta PT-s PB-s">
      <div class="name MB-xxs FZ-14 FW-b">{{ product.name }}</div>
      <vue-markdown
        class="desc MB-xxs FZ-14 LH-140 C-grey"
        v-if="product.desc"
        :source="product.desc"
        :anchor-attributes="{ target: '_blank', rel: 'nofollow' }"
        :html="false"
        :postrender="htmlToText"
      ></vue-markdown>
      <div>
        <template v-if="'sale_price' in product">
          <template v-if="product.sale_price > product.price">
            <span class="price FZ-14 C-grey">
              ${{ product.sale_price.toLocaleString() }}
            </span>
          </template>
          <template v-else>
            <span class="price FZ-14 C-grey">
              ${{ product.sale_price.toLocaleString() }}
            </span>
            <span class="original-price FZ-14 C-grey">
              ${{ product.price.toLocaleString() }}
            </span>
          </template>
        </template>
        <template v-else>
          <span class="price FZ-14 C-grey">
            ${{ product.price.toLocaleString() }}
          </span>
        </template>
      </div>
    </div>
    <div class="right ML-m">
      <template v-if="product.soldOut">
        <div class="FZ-14 FW-b C-grey">{{ $t('product.soldOut') }}</div>
      </template>
      <template v-else-if="amount > 0">
        <div class="amount BGC-brand BDRS-s FW-b FZ-16 TA-c">
          {{ amount }}
        </div>
      </template>
      <template v-else>
        <div
          class="add P-xxs BDRS-99 BGC-light"
          v-if="!('readonly' in this.$route.query)"
        >
          <span class="material-icons-round C-light-grey">add</span>
        </div>
      </template>
    </div>
  </div>
  <div
    v-else-if="layout === 'GRID'"
    class="comp-container comp-container__product-item comp-container__product-item--grid"
    :class="{ 'is-sold-out': product.soldOut }"
    :data-id="product.id"
  >
    <div
      class="image POS-r"
    >
      <div
        class="POS-a TRBL-0 BDRS-m BGC-light BGR-n BGP-c-c BGZ-c"
        v-lazy:background-image="product.image_m || product.image"
      >
        <span class="no-image material-icons-round P-l POS-a BDRS-99 BGC-white C-light FZ-36" v-if="!product.image">photo</span>
        <template v-if="product.soldOut">
          <div class="sold-out POS-a PT-xxs PR-s PB-xxs PL-s BDRS-99 BGC-white FZ-14 FW-b C-dark">{{ $t('product.soldOut') }}</div>
        </template>
        <template v-else-if="amount > 0">
          <div class="amount POS-a BGC-brand BDRS-s FW-b FZ-16 TA-c">
            {{ amount }}
          </div>
        </template>
        <template v-else>
          <div
            class="add POS-a P-xxs BDRS-99 BGC-light"
            v-if="!('readonly' in this.$route.query)"
          >
            <span class="material-icons-round C-grey">add</span>
          </div>
        </template>
      </div>
    </div>
    <div class="meta PT-s PB-s">
      <div class="name MB-xxs FZ-14 FW-b">{{ product.name }}</div>
      <div class="desc MB-xxs FZ-14 LH-140 C-grey" v-if="product.desc">{{ product.desc }}</div>
      <div>
        <template v-if="'sale_price' in product">
          <template v-if="product.sale_price > product.price">
            <span class="price FZ-14 C-grey">
              ${{ product.sale_price.toLocaleString() }}
            </span>
          </template>
          <template v-else>
            <span class="price FZ-14 C-grey">
              ${{ product.sale_price.toLocaleString() }}
            </span>
            <span class="original-price FZ-14 C-grey">
              ${{ product.price.toLocaleString() }}
            </span>
          </template>
        </template>
        <template v-else>
          <span class="price FZ-14 C-grey">
            ${{ product.price.toLocaleString() }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import VueMarkdown from 'vue-markdown';

Vue.use(VueLazyload);

export default {
  components: { VueMarkdown },
  props: ['product', 'amount', 'layout'],
  methods: {
    htmlToText(html) {
      return html.replace(/<[^>]+>/g, '');
    },
  },
};
</script>

<style lang="sass" scoped>
.comp-container__product-item
  cursor: pointer

  &:active
    background-color: transparentize($color-light, .5)

  &.is-sold-out
    .image
      opacity: .5

  &--list
    display: flex
    align-items: center

    .image
      width: 104px
      height: 104px
      min-width: 104px

      img
        width: 100%
        height: auto

    .meta
      flex-grow: 1

    .name
      word-break: break-all

    .desc
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      text-overflow: ellipsis
      overflow: hidden
      display: -webkit-box

    .original-price
      text-decoration: line-through

    .right
      min-width: 32px

    .add
      @extend .W-xl
      @extend .H-xl

      span
        @extend .W-l
        @extend .H-l

    .amount
      width: 32px
      height: 32px
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center

      line-height: 32px

  &--grid
    width: 50%
    .image
      padding-top: 100%

    .name
      display: -webkit-box
      -webkit-box-orient: vertical
      -webkit-line-clamp: 2
      overflow: hidden

    .desc
      text-overflow: ellipsis
      white-space: nowrap
      overflow: hidden

    .original-price
      text-decoration: line-through

    .no-image
      top: 50%
      left: 50%

      transform: translate(-50%, -50%)

    .sold-out
      right: $size-xs
      bottom: $size-xs

    .add
      right: $size-xs
      bottom: $size-xs
      @extend .W-xl
      @extend .H-xl

      span
        @extend .W-l
        @extend .H-l

    .amount
      top: -$size-s
      right: -$size-s
      width: 32px
      height: 32px
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center

      line-height: 32px
</style>
